import { goBack, search } from "assets/icons";
import styled from "@emotion/styled";
import { Button, Card, Col, Form, Input, Row, Tabs, Typography } from "antd";
import React, { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DropDownAgent from "./DropDownAgent";
import AgentCard from "../AgentCard";
import ProductByAgent from "./ProductByAgent";
import HandshackeAgent from "./HandshackeAgent";
import AboutAgent from "./AboutAgent";
import { useGetAgentById } from "hooks/useAgents";
import { setLoading } from "store/slices/loadingSlice";
import { useAppDispatch } from "store";

interface ManageAgentByIdProps {
  id: string;
}



const ManageAgentById: FC<ManageAgentByIdProps> = ({id}) => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const { data, isLoading, isError } = useGetAgentById(id);

  

  
  useEffect(() => {
    if (isLoading) {
      dispatch(setLoading(true));
    } else {
      dispatch(setLoading(false));
    }
  }, [isLoading]);

  useEffect(() => {
    if (isError) {
      navigate("/not-found");
    }
  }, [isError]);


  const items = [
    {
      label: `สินค้า`,
      key: "1",
      children: <ProductByAgent  />,
    },
    {
      label: `รายการร่วมกัน`,
      key: "2",
      children: <HandshackeAgent data={data?.contact} />,
    },
    {
      label: `เกี่ยวกับ`,
      key: "3",
      children: <AboutAgent data={data?.contact} />,
    },
  ];



  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <ColumnWrapper>
              <HeaderTabs>
                <IconWrapper
                  onClick={() => {
                    navigate("/manage-agent");
                  }}
                >
                  <SpanIcon>{goBack}</SpanIcon>
                </IconWrapper>

                <RightIconWrapper>
                  <Form layout="inline">
                    <Form.Item name="search">
                      <Input placeholder="ค้นหาสินค้า" size="small" />
                    </Form.Item>
                    <DropDownAgent id={id} />
                  </Form>
                </RightIconWrapper>
              </HeaderTabs>
              <AgentsCardWrapper>
                <AgentCard data={data?.contact} />
              </AgentsCardWrapper>
            </ColumnWrapper>
            <WrapperAll>
              <Tabs
                defaultActiveKey="1"
                style={{ height: "100%" }}
                items={items}
                key="key"
              />
            </WrapperAll>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ManageAgentById;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const AgentsCardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
`;
